import { FC } from 'react';
import { Flex, Image } from '@chakra-ui/react';

import magnifyingGlass from 'assets/brand/mag-glass.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import locales from './locales';

interface EmptyListProps {
  onSearchReset: () => void;
}

const EmptyList: FC<EmptyListProps> = ({ onSearchReset }) => {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap="space-8"
      height="336px"
      justifyContent="center"
      width="100%"
    >
      <Image
        alt="magnifying glass"
        height="112px"
        marginBottom="space-6"
        src={magnifyingGlass}
        width="112px"
      />
      <Text fontWeight="weight-500" size="lg" variant="primary">
        {locales.title}
      </Text>
      <Button
        icon="arrow-right"
        onClick={onSearchReset}
        size="md"
        variant="inline-primary"
      >
        {locales.button}
      </Button>
    </Flex>
  );
};

export default EmptyList;
